export enum SeatsRowGroupType {
    first,
    front,
    emergency,
    rear
}
